export function initializeFetchEmailDiagnostics(logrocket, doc, win) {
  // Observe before LiveView changes the DOM. Do not intercept or replay clicks.
  const onClick = (event) => {
    const target =
      event.target.nodeType === 3 ? event.target.parentElement : event.target
    const button = target.closest?.("button")
    if (!button) return

    const action = button.getAttribute("phx-click")
    const opener = action === "email-button" && button.id.startsWith("fetch-")
    const confirmation =
      action === "fetch-email" &&
      button.closest("#popup-confirm-email-fetch") !== null
    if (!opener && !confirmation) return

    const popup = doc.getElementById("popup-confirm-email-fetch")
    const popupStyle = popup && win.getComputedStyle(popup)
    const popupOpacity = popupStyle ? Number(popupStyle.opacity) : 0
    let effectiveOpacity = popupOpacity
    for (
      let parent = popup?.parentElement;
      parent;
      parent = parent.parentElement
    ) {
      effectiveOpacity *= Number(win.getComputedStyle(parent).opacity)
    }

    const overlapsFetchButton = Array.from(
      doc.querySelectorAll('button[id^="fetch-"][phx-click="email-button"]'),
    ).some((fetchButton) => {
      const rect = fetchButton.getBoundingClientRect()
      return (
        rect.width > 0 &&
        rect.height > 0 &&
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom
      )
    })

    logrocket.track("Fetch Email interaction", {
      action,
      button_id: button.id,
      contact_ref: button.getAttribute("phx-value-id"),
      trusted: event.isTrusted,
      click_count: event.detail,
      x: event.clientX,
      y: event.clientY,
      event_time_ms: event.timeStamp,
      popup_present: popup !== null,
      popup_opacity: popupOpacity,
      popup_effective_opacity: effectiveOpacity,
      popup_display: popupStyle?.display ?? null,
      popup_visibility: popupStyle?.visibility ?? null,
      popup_has_layout: popup !== null && popup.getClientRects().length > 0,
      overlaps_fetch_button: overlapsFetchButton,
    })
  }

  doc.addEventListener("click", onClick, true)
  return () => doc.removeEventListener("click", onClick, true)
}
